import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { CompanyService } from "../../../../service/CompanyService";
import type { User } from "../../../../util/Types/User";

interface UserCompany {
  id: string;
  name: string;
  logo?: string;
  isCompanyOwner?: boolean;
}

export function useShowDashboardVisibilityOptions(
  authUser: User | null,
): boolean {
  const { isPending, data: companies = [] } = useQuery({
    queryKey: [
      "layoutBetaUserCompanies",
      authUser?.id,
      authUser?.selectedCompanyId,
    ],
    queryFn: async (): Promise<UserCompany[]> => {
      const res = await CompanyService.getUserCompanies();
      const list = res?.data;
      if (!Array.isArray(list)) {
        return [];
      }
      return list as UserCompany[];
    },
    enabled: Boolean(authUser?.id),
  });

  return useMemo(() => {
    if (isPending || !authUser?.id) {
      return false;
    }
    if (!authUser.selectedCompanyId) {
      return false;
    }
    const myCompany = companies.find((c) => c.isCompanyOwner) ?? null;
    if (!myCompany?.id) {
      return false;
    }
    return authUser.selectedCompanyId !== myCompany.id;
  }, [
    isPending,
    authUser?.id,
    authUser?.selectedCompanyId,
    companies,
  ]);
}
